import { company_name } from "@/i18n/variables";

const inputs = {
	account_type: {
		label: "Wählen Sie Ihren Kontotyp aus",
		values: {
			business: "Geschäftlich",
			private: "Privat",
		},
	},
	address: {
		label: "Adresse",
		placeholder: "Zum Beispiel, Platz der Republik 1",
	},
	categories: {
		label: "Tags",
	},
	city: {
		label: "Wohnort",
		placeholder: "Zum Beispiel Köln",
	},
	city_of_birth: {
		label: "Ort der Geburt",
		placeholder: "Ort der Geburt",
	},
	coc_number: {
		label: "Handelsregisternummer",
		placeholder: "Zum Beispiel 74698818",
	},
	company_name: {
		label: "Firmenname",
		placeholder: `Zum Beispiel ${company_name}`,
	},
	company_number: {
		label: "-Nummer",
		placeholder: "-Nummer",
	},
	country: {
		label: "Land",
		placeholder: "Zum Beispiel Deutschland",
	},
	country_of_birth: {
		label: "Land der Geburt",
		placeholder: "Land der Geburt",
	},
	country_select: {
		label: "Wählen Sie Ihr Herkunftsland aus",
	},
	created_at: {
		label: "Hinzugefügt am",
	},
	date_of_birth: {
		label: "Datum der Geburt",
	},
	department: {
		label: "Abteilungsname",
		placeholder: "Zum Beispiel Einkauf",
	},
	description: {
		description: "Beschreibung",
		label: "Beschreibung",
	},
	email_address: {
		label: "E-Mail-Adresse",
		placeholder: `Zum Beispiel info@${company_name}.nl`,
	},
	email_address_billing: {
		info: "Ihre Rechnungen werden an diese Adresse gesendet.",
		label: "Rechnungs-E-Mail-Adresse",
		placeholder: `Zum Beispiel administration@${company_name}.nl`,
	},
	email_address_reminders_and_warnings: {
		label: "Unterschiedliche E-Mail-Adressen für Mahnungen und Mahnschreiben",
		placeholder: `Zum Beispiel administratie@${company_name}.nl`,
	},
	family_name: {
		label: "Nachname",
		placeholder: "Zum Beispiel Janssen",
	},
	given_name: {
		label: "Vorname",
		placeholder: "Zum Beispiel Henk",
	},
	house_number: {
		label: "Hausnummer",
		placeholder: "Zum Beispiel 29",
	},
	house_number_appendix: {
		label: "Zusatz",
		placeholder: "Zum Beispiel D",
	},
	house_number_with_appendix: {
		label: "Hausnummer und Zusatz",
		placeholder: "Zum Beispiel 29",
	},
	identification_issue_date: {
		label: "Ausgabedatum identitätsbeweis",
	},
	identification_issuer: {
		label: "Ausstellende Behörde identitätsbeweis",
		placeholder: "Zum Beispiel Bürgermeister von Ede",
	},
	identification_number: {
		label: "Nummer identitätsbeweis",
		placeholder: "Zum Beispiel 000000001",
	},
	ip_address: {
		label: "IP-Adresse",
	},
	language: {
		label: "Sprache",
		label_alt: "Kommunikation Sprache",
		language_list: {
			de: "Deutsch",
			en: "Englisch",
			nl: "Niederländisch",
		},
	},
	last_login: {
		label: "Zuletzt angemeldet am",
	},
	membership_type: {
		label: "Kontotyp",
		values: {
			business: "Geschäftlich",
			private: "Privat",
		},
	},
	middle_name: {
		label: "Namenszusatz",
		placeholder: "Zum Beispiel van der",
	},
	name: {
		label: "Name",
	},
	otp: {
		label: "Geben Sie Ihren 2FA-Code ein",
		placeholder: "Zum Beispiel 129432",
	},
	password: {
		label: "Passwort",
		placeholder:
			"Verwenden Sie mindestens 8 Zeichen, einschließlich Zahlen, Buchstaben und Symbolen",
	},
	password_current: {
		label: "Aktuelles Passwort",
		placeholder: "Ihr aktuelles Passwort",
	},
	password_new: {
		label: "Neues Passwort",
		placeholder:
			"Verwenden Sie mindestens 8 Zeichen, einschließlich Zahlen, Buchstaben und Symbolen",
	},
	password_new_repeat: {
		label: "Neues Passwort wiederholen",
		placeholder: "Wiederholen Sie Ihr neues Passwort",
	},
	password_repeat: {
		label: "Passwort wiederholen",
		placeholder: "Wiederholen Sie Ihr Passwort",
	},
	phone_number: {
		duplicate_dial_code:
			'Hinweis: Das von Ihnen ursprünglich ausgewählte Land kann sich unterscheiden, da mehrere Länder den Ländercode "{{dial_code}}" verwenden. Dies hat keinen Einfluss auf die gespeicherte Rufnummer.',
		info: "Wir werden Sie unter dieser Nummer bei Fragen zu den Rechnungen anrufen.",
		label: "Telefonnummer",
		placeholder: "Zum Beispiel 6 1234 5678",
	},
	private_network_description: {
		label: "Beschreibung",
		placeholder: "Beschreibung Ihres privaten Netzwerks",
	},
	private_network_name: {
		label: "Name",
		placeholder: "Name Ihres privaten Netzwerks",
	},
	province: {
		label: "Bundesland",
		placeholder: "Bundesland",
	},
	relation_autocomplete: {
		add_new: "Neue Beziehung hinzufügen",
		label: "Beziehung auswählen",
		placeholder: "Wählen Sie eine Beziehung aus oder erstellen Sie eine neue",
	},
	salutation: {
		label: "Anrede",
		values: {
			d: "Abteilung",
			department: "Abteilung",
			f: "Frau",
			female: "Frau",
			m: "Herr",
			male: "Herr",
		},
	},
	street_name: {
		label: "Straßenname",
		placeholder: "Zum Beispiel Darwinstraat",
	},
	trademark_country: {
		label: "Markenland",
		placeholder: "Markenland",
	},
	trademark_name: {
		label: "Markenname",
		placeholder: "Markenname",
	},
	trademark_number: {
		label: "Markennummer",
		placeholder: "Markennummer",
	},
	user_select: {
		label: "Benutzer auswählen",
		placeholder: "Wählen Sie einen Benutzer aus",
	},
	username: {
		label: "Benutzername",
		new_user_placeholder: "Zum Beispiel Hans",
		placeholder: "Zum Beispiel hans@DB0001",
	},
	vat_number: {
		label: "USt-IdNr",
		placeholder: "Zum Beispiel NL859996657B01",
	},
	zip_code_of_birth: {
		label: "Postleitzahl Geburtsor",
		placeholder: "Zum Beispiel 6718XR",
	},
	zipcode: {
		label: "Postleitzahl",
		placeholder: "Zum Beispiel 6718XR",
	},
};

export default inputs;
